import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const SIDE_IMG =
  'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=900&q=80';
const PANEL_IMG =
  'https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=900&q=80';

const Benefits = () => {
  const { t } = useLanguage();

  return (
    <section id="vorteile" className="py-24 bg-[#090b12]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-accent text-sm font-bold uppercase tracking-[0.2em]">{t.advantages.kicker}</span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-white font-heading">
            {t.advantages.title}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent">
              {t.advantages.titleGrad}
            </span>
          </h2>
          <p className="mt-4 text-lg text-slate-400 max-w-2xl mx-auto">{t.advantages.intro}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 items-stretch">
          <div className="relative rounded-[2rem] overflow-hidden min-h-[420px] ring-1 ring-white/10 group">
            <img
              src={SIDE_IMG}
              alt={t.advantages.imageAlt}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              width={900}
              height={1100}
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-dark via-dark/40 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8 lg:p-10">
              <p className="text-3xl lg:text-4xl font-heading font-extrabold text-white max-w-sm leading-tight">
                {t.advantages.quote}
              </p>
              <p className="mt-4 text-slate-300 max-w-md leading-relaxed">{t.advantages.quoteSub}</p>
              <a
                href="/s"
                className="mt-8 inline-flex items-center gap-2 w-fit bg-gradient-to-r from-primary to-violet text-white font-bold px-6 py-3 rounded-xl shadow-glow hover:-translate-y-0.5 transition-transform"
              >
                {t.advantages.cta}
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="bg-card-dark border border-border-dark rounded-[2rem] p-8 lg:p-10 flex-1">
              <ul className="space-y-5">
                {t.advantages.bullets.map((line) => (
                  <li key={line} className="flex gap-4 items-start">
                    <span className="mt-1 w-8 h-8 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center shrink-0">
                      <Check className="w-4 h-4 text-primary-light" />
                    </span>
                    <span className="text-lg text-slate-200 font-medium leading-snug">{line}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="grid sm:grid-cols-2 gap-6 flex-1">
              <div className="relative rounded-2xl overflow-hidden min-h-[200px] ring-1 ring-border-dark">
                <img
                  src={PANEL_IMG}
                  alt={t.advantages.panelAlt}
                  className="absolute inset-0 w-full h-full object-cover"
                  width={450}
                  height={300}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark/95 to-dark/20" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="text-[10px] font-bold uppercase tracking-widest text-accent">{t.advantages.panelKicker}</p>
                  <p className="text-white font-heading font-bold text-lg mt-1">{t.advantages.panelTitle}</p>
                </div>
              </div>
              <div className="bg-gradient-card border border-border-dark rounded-2xl p-6 flex flex-col justify-center">
                <p className="text-slate-300 text-sm leading-relaxed">{t.advantages.panelBody}</p>
                <p className="mt-4 text-slate-400 text-sm leading-relaxed border-t border-border-dark pt-4">
                  {t.advantages.panelSub}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
